import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Form,
    CustomInput,
    FormGroup,
} from 'reactstrap';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
export default function FacebookInfo({
    integration,
    integrationProperties,
    allProperties
}) {
    const [formatedProperties, setFormatedProperties] = useState([]);
    useEffect(() => {
        const result = integrationProperties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        setFormatedProperties(result);
    }, [integrationProperties, allProperties]);

    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>
                        Select Properties
                    </h6>
                    <Separator className="mb-3" />
                    <h1>{integration ? integration.name : null}</h1>
                    <div>
                        <h6>Group</h6>
                        <div className="mb-2">
                            <span className="text-muted">
                                ({integration ? integration.groupId : null})
                            </span>
                        </div>
                    </div>
                    <div>
                        <h6>Properties</h6>
                        <div className="mb-2">
                            {formatedProperties
                                ? formatedProperties.map((elem, index) => {
                                    return (
                                        <div key={index} className="mb-2">
                                            <b>{elem ? elem.name : null}</b>{' '}
                                            <span className="text-muted">
                                                ({elem ? elem.id : null})
                                            </span>
                                        </div>
                                    );
                                })
                                : null}
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>);
}